export default __webpack_public_path__ + "static/adventures-398b92116363d8fb5b4fff398963bfc7.gif";